import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'Andrés R.',
  location: 'Buenos Aires, Argentina'
}, {
  name: 'María C.',
  location: 'CDMX, México'
}, {
  name: 'Juan P.',
  location: 'Bogotá, Colombia'
}, {
  name: 'Felipe L.',
  location: 'Santiago, Chile'
}, {
  name: 'Ana M.',
  location: 'Lima, Perú'
}, {
  name: 'Carlos R.',
  location: 'Montevideo, Uruguay'
}, {
  name: 'Sofía M.',
  location: 'Quito, Ecuador'
}, {
  name: 'Daniel G.',
  location: 'Caracas, Venezuela'
}, {
  name: 'Laura P.',
  location: 'Guatemala'
}];
const accentColors = ['text-brand-cta', 'text-brand-gold'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  const [colorIndex, setColorIndex] = useState(0);
  useEffect(() => {
    const initialTimer = setTimeout(() => showNextPopup(), 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
    setColorIndex(prev => (prev + 1) % accentColors.length);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(showNextPopup, Math.floor(Math.random() * 8000) + 8000);
    }, 4000);
  };
  if (!isVisible) return null;
  const nameColor = accentColors[colorIndex];
  const checkColor = colorIndex === 0 ? 'text-brand-cta' : 'text-brand-gold';
  return <div className="fixed bottom-3 left-3 z-50 animate-[slideIn_0.3s_ease-out] max-w-[230px]" data-id="element-205">
      <div className="bg-brand-card rounded-xl shadow-[0_0_12px_rgba(255,255,255,0.06)] border border-white/15 p-2.5 flex items-center gap-2 relative overflow-hidden" data-id="element-206">
        <div className="shrink-0" data-id="element-207">
          <CheckCircle className={`w-4 h-4 ${checkColor}`} data-id="element-208" />
        </div>
        <div data-id="element-209">
          <p className="text-[9px] text-gray-300 font-normal leading-tight mb-0.5" data-id="element-210">
            <span className={`font-semibold ${nameColor}`} data-id="element-211">
              {currentPurchase.name}
            </span>{' '}
            de {currentPurchase.location} compró el Kit 💻
          </p>
          <p className="text-[8px] text-gray-500 font-medium" data-id="element-212">
            Hace unos minutos
          </p>
        </div>
      </div>
      <style data-id="element-213">{`
        @keyframes slideIn {
          from { transform: translateX(-120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>;
}